export const SUPPORTED_PLATFORMS = [
  'Salesforce',
  'ServiceNow',
  'Microsoft Dynamics 365',
  'SAP',
  'Oracle',
] as const;

export type PlatformType = (typeof SUPPORTED_PLATFORMS)[number];
